import EvolutionBoxDash from './EvolutionCumulPromoBoxDashboard';

export const EvolutionCumulPromoBoxDashboard = EvolutionBoxDash;
